class HeaderMenu {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $(window).scroll(function () {
      if($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        $('html').removeClass('is-scroll');
      }
    });

    function handleMenuToggle() {
      if (window.innerWidth <= 768) {

        $('.js-mega-trigger').click(function() {
          $(this).toggleClass('is-active');
          $(this).next('.js-h-mega').slideToggle();
          $('js-h-overlay').toggleClass('is-open');
        });

        $('.l-header-content a').on('click', function() {
          $('html').removeClass('is-open');
        });
    
      } else {
        $('.js-mega-trigger').hover(
          function () {
            const megaContent = $(this).next('.js-h-mega');
            const contentHeight = megaContent.prop('scrollHeight');
            megaContent.css({ height: contentHeight + 'px'});
            $('.js-h-overlay').addClass('is-active');
          },
          function () {
            const megaContent = $(this).next('.js-h-mega');
            if (!$(megaContent).is(':hover')) {
              megaContent.css({ height: '0'});
              $('.js-h-overlay').removeClass('is-active');
            }
          }
        );
      
        $('.js-h-mega').hover(
          function () {
            $(this).css({ height: $(this).prop('scrollHeight') + 'px' });
            $('.js-h-overlay').addClass('is-active');
          },
          function () {
            if (!$('.js-mega-trigger:hover').length) {
              $(this).css({ height: '0' });
              $('.js-h-overlay').removeClass('is-active');
            }
          }
        );

        // $('.js-mega-trigger').hover(
        //   function() {
        //     const $megaMenu = $(this).next('.js-h-mega');
        //     $megaMenu.addClass('is-active');
        //     $(this).addClass('is-active');
        //     $('.js-h-overlay').addClass('is-active');
        //   },
        //   function() {
        //     const $megaMenu = $(this).next('.js-h-mega');
        //     $megaMenu.removeClass('is-active');
        //     $(this).removeClass('is-active');
        //     $('.js-h-overlay').removeClass('is-active');
        //   }
        // );
        
        // $('.js-h-mega').hover(
        //   function() {
        //     $(this).addClass('is-active');
        //     $(this).prev('.js-mega-trigger').addClass('is-active');
        //     $('.js-h-overlay').addClass('is-active');
        //   },
        //   function() {
        //     $(this).removeClass('is-active');
        //     $(this).prev('.js-mega-trigger').removeClass('is-active');
        //     $('.js-h-overlay').removeClass('is-active');
        //   }
        // );
      }
    }

    handleMenuToggle();

    $('.js-drawer').click(function () {      
      $('html').toggleClass('is-open');
      $('.l-header-logo').toggleClass('is-active');
      // fixedBody();
    });
    
    const body = $('body');
    let status = false;
    let pos = 0;
  
    function fixedBody() {
      if (!status) {
        pos =
          window.scrollY ||
          window.scrollTop ||
          document.getElementsByTagName('html')[0]?.scrollTop ||
          0;
  
        body.addClass('fixed');
        $('body').css('top', -pos + 'px');
        status = true;
      } else {
        body.removeClass('fixed');
        $('body').css('top', '0');
        window.scrollTo(0, pos);
        status = false;
      }
    }

  }
}
